import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';

import VisibilityIcon from '@mui/icons-material/Visibility';
import TableRow from '@mui/material/TableRow';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import SearchIcon from '@mui/icons-material/Search';

import { Columns } from 'react-feather';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import InfoIcon from '@mui/icons-material/Info';
// Import PDF Icon
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

import dayjs from 'dayjs';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import api from '../../utils/functions/api';
import { usePendingQuery, useApprovedQuery } from '../../services/evidencePay';
import axios from '../../utils/functions/api';

import addCommas from '../../utils/functions/commas';
import Loading from '../../components/Loading';
import jsPDF from 'jspdf';
import { ROLES } from '../../utils/constants';
import { checkAccessRights } from '../../utils/functions/accessRight';
import RestoreIcon from '@mui/icons-material/Restore';
import jwtDecode from 'jwt-decode';
import { getStorage } from '../../utils/functions/localstorage';
import Swal from 'sweetalert2';
import ReverseDialog from '../../components/Dialog/ReverseDialog';
import SortableTableLabel from '../../components/Table/SortableTableLabel';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { useTranslation } from 'react-i18next';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#fff', 
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
  '&:hover': {
    boxShadow: '0 6px 16px rgba(0,0,0,0.12)',
    position: 'relative',
    zIndex: 10,
    cursor: 'pointer',
  },
  transition: 'transform 0.15s ',
}));

function Approved() {
  const { t } = useTranslation();

  const toNumber = (value) => {
    const parsed = Number(String(value ?? '').replace(/,/g, ''));
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const getCustomerCodes = (record = {}) => [
    ...(Array.isArray(record.customer_codes) ? record.customer_codes : []),
    record.customer_code,
  ].filter(Boolean);

  const isMultipleCustomer = (record = {}) =>
    record.is_multi_customer || [...new Set(getCustomerCodes(record))].length > 1;

  const getCustomerNames = (record = {}) =>
    [...new Set(
      (Array.isArray(record.invoice_customers) ? record.invoice_customers : [])
        .map((item) => String(item?.customer_name || '').trim())
        .filter(Boolean)
    )];

  const getCustomerName = (record = {}, fallback = '') => {
    const names = getCustomerNames(record);
    return names.length > 0 ? names.join(', ') : fallback || '-';
  };

  const columns = [
    { id: 'trans_ref', label: t('app.transactionRefNo'), minWidth: 100 },
    {
      id: 'upload_ref',
      label: t('app.uploadRef'),
      minWidth: 100,
      align: 'center',
    },
    
    {
      id: 'rc_03',
      label: t('app.documentRC03No'),
      minWidth: 100,
      align: 'center',
    },
    {
      id: 'invoice_no',
      label: t('app.invoiceNo'),
      minWidth: 170,
      align: 'center',
    },
    {
      id: 'customer_code',
      label: t('navbar.custNo'),
      minWidth: 130,
      align: 'center',
    },
    {
      id: 'customer_name',
      label: t('app.customerName'),
      minWidth: 100,
      align: 'center',
    },
    {
      id: 'finance_name',
      label: t('app.financeOfficer'),
      minWidth: 100,
      align: 'center',
    },
    {
      id: 'total_pay_amount',
      label: t('app.grandTotalNoThb'),
      minWidth: 100,
      align: 'center',
    },
    {
      id: 'transfered_date',
      label: t('app.paymentDate'),
      minWidth: 100,
      align: 'center',
    },
    {
      id: 'approveAt',
      label: t('app.approvedDate'),
      minWidth: 120,
      align: 'center',
    },
    { id: 'action', label: t('app.detail'), minWidth: 100, sortable: false },
    { id: 'reverse', label: t('app.reverse'), minWidth: 100, sortable: false },
  ];

  const token = getStorage('token');
  const decoded = jwtDecode(token);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0); 
  const [sortBy, setSortBy] = useState('approveAt');
  const [sortOrder, setSortOrder] = useState('desc');
  const [total, setTotal] = useState(10);
  const [reason, setReason] = useState('');
  const [openDialogReverse, setOpenDialogReverse] = useState(false);
  const [selectedTransRef, setSelectedTransRef] = useState(null);
  const [touched, setTouched] = useState(false);

  const handleOpenReverse = (item) => {
    setSelectedTransRef(item);
    setOpenDialogReverse(true);
  };

  const handleCloseReverse = () => {
    setOpenDialogReverse(false);
    setReason('');
  };

  const [selectedInvoiceApproved, setSelectedInvoiceApproved] = useState();
  const [transaction, setTransaction] = useState();
  const [invoiceNumber, setInvoiceNumber] = useState();
  const { value: merchant, allMerchant } = useSelector(
    (state) => state.merchant,
  );
  const [searchAll, setSearchAll] = useState('');
  const [open, setOpen] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState();
  const [isDialogLoading, setIsDialogLoading] = useState(false);

  // --- 1. Helper: Check File Type ---
  const getFileType = (base64) => {
    if (base64 && base64.startsWith('JVBERi0')) {
      return 'pdf';
    }
    return 'image';
  };

  // --- 2. Logic: Open PDF Directly ---
  const openPdfDirectly = (base64) => {
    try {
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(blob);
      window.open(fileURL, '_blank');
    } catch (error) {
      console.error('Error opening PDF:', error);
    }
  };

  // --- 3. Logic: Convert Image to PDF (Existing Logic) ---
  const convertImageToPdf = (imgBase64) => {
    const img = new Image();
    img.src = `data:image/jpeg;base64,${imgBase64}`;

    img.onload = function () {
      const imgWidth = this.width;
      const imgHeight = this.height;

      const pdf = new jsPDF({
        orientation: imgWidth > imgHeight ? 'l' : 'p',
        unit: 'pt',
        format: [imgWidth, imgHeight],
      });

      pdf.addImage(this, 'JPEG', 0, 0, imgWidth, imgHeight);
      const pdfBlob = pdf.output('blob');
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const finalUrl = `${pdfUrl}#zoom=100`;
      window.open(finalUrl, '_blank');
    };

    img.onerror = function () {
      console.error('ไม่สามารถโหลดรูปภาพสำหรับ PDF ได้');
    };
  };

  // --- 4. Main Handler ---
  const handlePreview = (base64) => {
    const type = getFileType(base64);
    if (type === 'pdf') {
      openPdfDirectly(base64);
    } else {
      convertImageToPdf(base64);
    }
  };

  // --- 5. Helper Component for Rendering File Preview ---
  const RenderFilePreview = ({ file, size = 300 }) => {
    const type = getFileType(file.imgBase64);
    
    if (type === 'pdf') {
        return (
          <div 
            className="relative border rounded shadow-md bg-gray-50 overflow-hidden group hover:scale-105 transition-transform duration-300"
            style={{ width: `${size}px`, height: `${size}px` }}
          >
            {/* Object tag for PDF Preview */}
            <object
              data={`data:application/pdf;base64,${file.imgBase64}`}
              type="application/pdf"
              width="100%"
              height="100%"
              className="w-full h-full pointer-events-none object-contain"
            >
               {/* Fallback if preview fails */}
               <div className="flex flex-col items-center justify-center h-full">
                   <PictureAsPdfIcon sx={{ fontSize: size/3, color: '#d32f2f' }} />
               </div>
            </object>

            {/* Clickable Overlay */}
            <div 
               className="absolute inset-0 cursor-pointer hover:bg-black/5 transition-colors z-10"
               onClick={() => handlePreview(file.imgBase64)}
            />

            {/* PDF Label */}
            <div className="absolute bottom-2 right-2 bg-white/90 px-2 py-1 rounded shadow-sm border flex items-center gap-1 z-20 pointer-events-none">
               <PictureAsPdfIcon sx={{ fontSize: 18, color: '#d32f2f' }} />
               <span className="text-xs font-bold text-gray-700">PDF</span>
            </div>
          </div>
        )
    }

    return (
        <div className="relative group">
            <img
                width={`${size}px`}
                height={`${size}px`}
                className="cursor-pointer border rounded object-cover shadow-md hover:scale-105 transition-transform"
                style={{ width: `${size}px`, height: `${size}px`, objectFit: 'contain', backgroundColor: '#f9f9f9' }}
                src={`data:image/jpeg;base64,${file.imgBase64}`}
                alt="Evidence"
                onClick={() => handlePreview(file.imgBase64)}
            />
        </div>
    )
  }

  const isAdminRole = checkAccessRights(ROLES.ADMIN_ROLE);
  const sorgcode = isAdminRole ? merchant || '' : allMerchant || '';
  const shouldSkip = isAdminRole && !merchant;

  const {
    data: approvedDetail,
    isLoading,
    refetch,
    isFetching,
  } = useApprovedQuery(
    {
      sorgcode,
      page: page === 0 ? 1 : page + 1,
      size: rowsPerPage,
      status: 'Approved',
      search: searchAll,
      sortBy,
      sortOrder,
    },
    {
      refetchOnMountOrArgChange: true,
      skip: shouldSkip,
    },
  );

  const handleClickOpen = async (detailID, approvedData) => {
    setIsDialogLoading(true);
    try {
      const { data } = await api.get(
        `${process.env.REACT_APP_API_URL_admin}/upload/detail?transactionId=${detailID}`,
      );

      setInvoiceNumber(data?.data?.invoice || []);
      setTransaction(data?.data?.transaction[0]);
      setSelectedInvoiceApproved({
        ...data?.data,
        approvedDetail: approvedData,
      });
      setOpen(true);
    } catch (error) {
      // handle error if needed
    } finally {
      setIsDialogLoading(false);
    }
  };

  const handleConfirmReverse = async () => {
    setTouched(true);

    if (!selectedTransRef || !reason.trim()) {
      return;
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL_admin}/upload/reverse-evidence`,
        {
          sorgcode: selectedTransRef?.sorgcode,
          orderIdRef: selectedTransRef?.trans_ref,
          status: 'Upload',
          approver: decoded?.NAME,
          reason,
          upload_ref: selectedTransRef?.upload_ref,
        },
      );

      Swal.fire({
        position: 'center',
        icon: 'success',
        title: t('app.reversalSuccessful'),
        showConfirmButton: false,
        timer: 3000,
        willOpen: () => {
          document.querySelector('.swal2-container').style.zIndex = '2000';
        },
      });

      refetch();
      handleCloseReverse();
      setTouched(false);
    } catch (error) {
      console.error('API Error:', error);
      Swal.fire({
        icon: 'error',
        title: 'เกิดข้อผิดพลาด',
        text: 'ไม่สามารถ Reverse ได้',
        confirmButtonText: 'ตกลง',
      });
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    setPage(0);
  }, [searchAll]);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleRequestSort = (property) => {
    setSortOrder(
      sortBy === property && sortOrder === 'asc' ? 'desc' : 'asc',
    );
    setSortBy(property);
    setPage(0);
  };

  useEffect(() => {
    if (approvedDetail) {
      const { pagination } = approvedDetail;
      setTotal(pagination.total);
    }
  }, [approvedDetail, searchAll]);

  const handleClose = () => {
    setOpen(false);
  };

  const approvalInvoices = Array.isArray(invoiceNumber) ? invoiceNumber : [];
  const approvalCustomerName = getCustomerName(
    transaction,
    transaction?.customer_name
  );

  return (
    <div>
      {/* <Loading isLoading={isLoading} /> */}
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1 }}
        open={isDialogLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className="flex flex-col">
        <div className="font-bold">Approved</div>
        <div className="w-full lg:w-[20%]">
          <Paper
            component="form"
            sx={{
              p: '2px 4px',
              display: 'flex',
              alignItems: 'center',
              marginTop: 2,
            }}
          >
            <InputBase
              className='"app-search-input'
              type="text"
              sx={{ ml: 1, flex: 1, width: 300 }}
              onChange={(e) => {
                setSearchAll(e.target.value);
              }}
              placeholder={t('app.search')}
            />

            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
            <div className="p-2">
              <SearchIcon sx={{ fontSize: '24px' }} color="primary" />
            </div>
          </Paper>
        </div>
      </div>

      <div className="flex flex-col mt-5">
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
   <TableContainer sx={{ overflowX: 'auto', overflowY: 'visible' }}>

            <Table size="small">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <StyledTableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                    >
                      <div style={{ whiteSpace: 'nowrap', padding: 5 }}>
                        <SortableTableLabel
                          column={column}
                          sortBy={sortBy}
                          sortOrder={sortOrder}
                          onSort={handleRequestSort}
                          color="white"
                        />
                      </div>
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>

              {isFetching ? (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : _.size(approvedDetail?.data) ? (
                <TableBody>
                  {approvedDetail?.data.map((item, index) => (
                    <StyledTableRow
                      style={{ whiteSpace: 'nowrap' }}
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={index}
                    >
                      {columns.map((column) => {
                        const value = item[column.id];

                        if (column.id === 'invoice_no') {
                          const invoiceList = (
                            Array.isArray(value)
                              ? value
                              : typeof value === 'string'
                                ? value.split(',').map((v) => v.trim())
                                : []
                          )
                            .filter(Boolean)
                            .sort();

                          return (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              sx={{
                                whiteSpace: 'nowrap',
                                wordBreak: 'break-word',
                                verticalAlign: 'top',
                                paddingY: 1.5,
                              }}
                            >
                              <div className="flex flex-col gap-1.5">
                                {invoiceList.length > 0 ? (
                                  invoiceList.map((inv, idx) => (
                                    <div
                                      key={idx}
                                      style={{
                                        fontFamily: 'monospace',
                                        fontSize: '0.85rem',
                                        fontWeight: 600,
                                        color: '#2c3e50',
                                        backgroundColor: '#f1f5f9',
                                        padding: '3px 10px',
                                        borderRadius: '6px',
                                        width: 'fit-content',
                                        display: 'inline-block',
                                        border: '1px solid #e2e8f0',
                                      }}
                                    >
                                      {inv}
                                    </div>
                                  ))
                                ) : (
                                  <span className="text-gray-400">-</span>
                                )}
                              </div>
                            </TableCell>
                          );
                        }

                        if (column.id === 'trans_ref') {
                          return (
                            <TableCell
                              sx={{
                                color: 'primary.light',
                                fontWeight: 'bold',
                                fontFamily: 'monospace',
                              }}
                              key={column.id}
                              align={column.align}
                            >
                              {value}
                            </TableCell>
                          );
                        }
                        if (column.id === 'upload_ref') {
                          return (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              sx={{
                                fontWeight: 'bold',
                                fontFamily: 'monospace',
                              }}
                            >
                              {value}
                            </TableCell>
                          );
                        }
                        if (column.id === 'rc_03') {
                          return (
                            <TableCell key={column.id} align={column.align}>
                              {value ? value : '-'}
                            </TableCell>
                          );
                        }
                        if (column.id === 'customer_code') {
                          const invoiceCustomers = Array.from(
                            new Map(
                              (Array.isArray(item.invoice_customers)
                                ? item.invoice_customers
                                : []
                              )
                                .filter((row) => row?.customer_code)
                                .map((row) => [
                                  `${row.invoice_no}|${row.customer_code}`,
                                  row,
                                ]),
                            ).values(),
                          ).sort((a, b) =>
                            String(a.invoice_no || '').localeCompare(
                              String(b.invoice_no || ''),
                            ),
                          );
                          const customerCodes = [...new Set(getCustomerCodes(item))];
                          return (
                            <TableCell key={column.id} align={column.align}>
                              {invoiceCustomers.length > 0 ? (
                                <div className="flex flex-col gap-1.5">
                                  {invoiceCustomers.map((row, index) => (
                                    <div
                                      key={`${row.invoice_no}-${row.customer_code}-${index}`}
                                      style={{
                                        fontFamily: 'monospace',
                                        fontSize: '0.85rem',
                                        fontWeight: 600,
                                        padding: '3px 10px',
                                        borderRadius: '6px',
                                        width: 'fit-content',
                                        margin: '0 auto',
                                      }}
                                    >
                                      {row.customer_code}
                                    </div>
                                  ))}
                                </div>
                              ) : (
                                customerCodes[0] || '-'
                              )}
                            </TableCell>
                          );
                        }
                        if (column.id === 'customer_name') {
                          return (
                            <TableCell key={column.id} align={column.align}>
                              {getCustomerName(item, value)}
                            </TableCell>
                          );
                        }
                        if (column.id === 'transfered_date') {
                          return (
                            <TableCell key={column.id} align={column.align}>
                              {dayjs(value).format('YYYY-MM-DD • HH:mm:ss')}
                            </TableCell>
                          );
                        }

                        if (column.id === 'action') {
                          return (
                            <TableCell key={column.id} align={column.align}>
                              <Button
                                onClick={() => {
                                  handleClickOpen(item._id, item);
                                }}
                              >
                                <InfoIcon />
                              </Button>
                            </TableCell>
                          );
                        }
                        if (column.id === 'reverse') {
                          return (
                            <TableCell key={column.id} align={column.align}>
                              <Button onClick={() => handleOpenReverse(item)}>
                                <RestoreIcon />
                              </Button>
                            </TableCell>
                          );
                        }

                        if (column.id === 'total_pay_amount') {
                          return (
                            <TableCell key={column.id} align={column.align}>
                              {addCommas(toNumber(item.total_pay_amount))}
                            </TableCell>
                          );
                        }
                        if (column.id === 'approveAt') {
                          return (
                            <TableCell key={column.id} align={column.align}>
                              {dayjs(value).format('YYYY-MM-DD • HH:mm:ss')}
                            </TableCell>
                          );
                        }

                        return (
                          <TableCell key={column.id} align={column.align}>
                            {value}
                          </TableCell>
                        );
                      })}
                    </StyledTableRow>
                  ))}
                </TableBody>
              ) : (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={9} align="center">
                      <div>ไม่มีข้อมูล</div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[5, 25, 100]}
            component="div"
            count={total}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>

      <Dialog
        open={open}
        maxWidth="md"
        fullWidth
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: '15px',
            width: '800px',
            maxWidth: 'none',
            height: '800px',
            minHeight: '600px',
            display: 'flex',
            flexDirection: 'column',
          },
        }}
      >
        <DialogTitle>
          <div className="font-bold text-lg text-gray-800">
            {t('app.approvalDetail')}
          </div>
        </DialogTitle>

        <DialogContent sx={{ overflowY: 'auto', padding: '16px 24px' }}>
          {/* PAYMENT SECTION */}
          <div className="mb-6">
            <div className="text-md font-semibold text-gray-700 mb-2 border-b pb-1 border-gray-300">
              {t('app.paymentProof')}
            </div>

            {selectedInvoiceApproved?.paymentFile?.length > 0 ? (
              selectedInvoiceApproved.paymentFile.length >= 3 ? (
                <Swiper
                  modules={[Navigation]}
                  spaceBetween={20}
                  slidesPerView={2}
                  navigation
                  breakpoints={{
                    0: { slidesPerView: 1 },
                    768: { slidesPerView: 2 },
                    1024: { slidesPerView: 3 },
                  }}
                  style={{ paddingBottom: '1rem' }}
                >
                  {selectedInvoiceApproved.paymentFile.map((file, index) => (
                    <SwiperSlide key={index}>
                      <div
                        className="text-center shadow-md p-2 rounded min-w-[200px] flex justify-center items-center"
                        style={{ height: '320px' }}
                      >
                          <Tooltip title="กดเพื่อดูเอกสาร" placement="top">
                            <div className="flex justify-center items-center w-full h-full">
                                <RenderFilePreview file={file} size={300} />
                            </div>
                          </Tooltip>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              ) : (
                <div className="flex flex-wrap justify-center gap-4">
                  {selectedInvoiceApproved.paymentFile.map((file, index) => (
                    <div
                      key={index}
                      className="text-center shadow-md p-2 rounded bg-white"
                    >
                      {file?.imgBase64 ? (
                        <Tooltip title="กดเพื่อดูเอกสาร" placement="top">
                           <div>
                              <RenderFilePreview file={file} size={180} />
                           </div>
                        </Tooltip>
                      ) : (
                        <div className="text-red-500">No Image</div>
                      )}
                    </div>
                  ))}
                </div>
              )
            ) : (
              <div className="text-gray-500 italic">
                ไม่มีหลักฐานการจ่ายเงิน
              </div>
            )}
          </div>

          {/* WHT SECTION */}
          {selectedInvoiceApproved?.whtFile?.length > 0 && (
            <div className="mb-6">
              <div className="text-md font-semibold text-gray-700 mb-2 border-b pb-1 border-gray-300">
                {t('app.whtDocument')}
              </div>

              {selectedInvoiceApproved.whtFile.length > 3 ? (
                <Swiper
                  modules={[Navigation]}
                  spaceBetween={20}
                  slidesPerView={2}
                  navigation
                  breakpoints={{
                    0: { slidesPerView: 1 },
                    768: { slidesPerView: 2 },
                    1024: { slidesPerView: 3 },
                  }}
                  style={{ paddingBottom: '1rem' }}
                >
                  {selectedInvoiceApproved.whtFile.map((file, index) => (
                    <SwiperSlide key={index}>
                      <div
                        className="text-center shadow-md p-2 rounded bg-white flex justify-center items-center"
                        style={{ height: '220px' }}
                      >
                          <Tooltip title="กดเพื่อดูเอกสาร" placement="top">
                            <div className="flex justify-center items-center w-full h-full">
                                <RenderFilePreview file={file} size={300} />
                            </div>
                          </Tooltip>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              ) : (
                <div className="flex flex-wrap justify-center gap-4">
                  {selectedInvoiceApproved.whtFile.map((file, index) => (
                    <div
                      key={index}
                      className="text-center shadow-md p-2 rounded bg-white flex justify-center items-center"
                      style={{ height: '220px' }}
                    >
                      <Tooltip title="กดเพื่อดูเอกสาร" placement="top">
                          <div>
                             <RenderFilePreview file={file} size={180} />
                          </div>
                      </Tooltip>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
          {/* INFO SECTION */}
          <div className="flex flex-col bg-gray-50 rounded-md p-4 border">
            <div className="space-y-3 text-sm text-gray-700">
              <div className="flex flex-col sm:flex-row">
                <div className="font-bold sm:w-40 sm:flex-shrink-0">
                  {t('app.transactionRefNo')}
                </div>

                <div className="text-green-700 sm:ml-4 break-words">
                  {transaction?.transaction_ref}
                </div>
              </div>

              <div className="flex flex-col sm:flex-row">
                <div className="font-bold sm:w-40 sm:flex-shrink-0">
                  {t('app.invoiceNo')}
                </div>
                <div className="sm:ml-4 break-words space-y-1">
                  {approvalInvoices.length > 0 ? (
                    approvalInvoices.map((item, index) => (
                      <div key={`${item.invoice_no}-${item.customer_code}-${index}`}>
                        <span>{item.invoice_no || '-'}</span>
                        <span className="ml-2 text-gray-500">
                          ({item.customer_code || '-'})
                        </span>
                      </div>
                    ))
                  ) : (
                    '-'
                  )}
                </div>
              </div>
              <div className="flex flex-col sm:flex-row">
                <div className="font-bold sm:w-40 sm:flex-shrink-0">
                  {t('app.bankAccountNo')}
                </div>
                <div className="sm:ml-4 break-words">
                  {transaction?.bank_no}
                </div>
              </div>

              <div className="flex flex-col sm:flex-row">
                <div className="font-bold sm:w-40 sm:flex-shrink-0">
                  {t('app.customerName')}
                </div>
                <div className="sm:ml-4 break-words">
                  {approvalCustomerName}
                </div>
              </div>

              <div className="flex flex-col sm:flex-row">
                <div className="font-bold sm:w-40 sm:flex-shrink-0">
                  {t('app.grandTotal')}
                </div>
                <div className="sm:ml-4 break-words">
                  {addCommas(transaction?.total_pay_amount)}
                </div>
              </div>

              <div className="flex flex-col sm:flex-row">
                <div className="font-bold sm:w-40 sm:flex-shrink-0">
                  {t('app.paymentAmount')}
                </div>
                <div className="sm:ml-4 break-words">
                  {addCommas(
                    transaction?.transfer_amount || transaction?.total_pay_amount,
                  )}
                </div>
              </div>

              <div className="flex flex-col sm:flex-row">
                <div className="font-bold sm:w-40 sm:flex-shrink-0">
                  {t('app.fee')}
                </div>
                <div className="sm:ml-4 break-words">
                  {transaction?.total_fee
                    ? addCommas(transaction.total_fee)
                    : '0.00'}
                </div>
              </div>

              <div className="flex flex-col sm:flex-row">
                <div className="font-bold sm:w-40 sm:flex-shrink-0">
                  {t('app.paymentDate')}
                </div>
                <div className="sm:ml-4 break-words">
                  {dayjs(transaction?.payment_date).format(
                    'YYYY-MM-DD • HH:mm:ss',
                  )}
                </div>
              </div>

              <div className="flex flex-col sm:flex-row">
                <div className="font-bold sm:w-40 sm:flex-shrink-0">
                  {t('app.approvedDate')}
                </div>
                <div className="sm:ml-4 break-words">
                  {dayjs(
                    selectedInvoiceApproved?.approvedDetail?.approveAt,
                  ).format('YYYY-MM-DD • HH:mm:ss')}
                </div>
              </div>
            </div>
          </div>
        </DialogContent>

        {/* FOOTER */}
        <DialogActions
          sx={{
            justifyContent: 'center',
            paddingBottom: 2,
            borderTop: '1px solid #eee',
            marginTop: 'auto',
          }}
        >
          <Button
            variant="contained"
            onClick={handleClose}
            sx={{ color: 'white', width: '100px' }}
          >
            {t('app.close')}
          </Button>
        </DialogActions>

        {/* Image Popup Dialog (Optional Backup) */}
        <Dialog open={isDialogOpen} onClose={() => setDialogOpen(false)}>
          <DialogTitle>รูปภาพ</DialogTitle>
          <DialogContent>
            {selectedImage && getFileType(selectedImage) !== 'pdf' ? (
                <img
                    width="500px"
                    height="500px"
                    src={`data:image/jpeg;base64,${selectedImage}`}
                    alt="Selected"
                    style={{ objectFit: 'contain' }}
                />
            ) : (
                <div className="flex flex-col items-center p-10">
                    <PictureAsPdfIcon sx={{ fontSize: 100, color: '#d32f2f' }} />
                    <p>Document is PDF</p>
                </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDialogOpen(false)}>ปิด</Button>
          </DialogActions>
        </Dialog>
      </Dialog>

      <ReverseDialog
        t={t}
        type="Approved"
        selectedTransRef={selectedTransRef}
        open={openDialogReverse}
        onClose={handleCloseReverse}
        onConfirm={handleConfirmReverse}
        reason={reason}
        setReason={setReason}
        touched={touched} 
      />
    </div>
  );
}

export default Approved;
